import { type FilterValues } from "components/filters/FilterContext";
import { DefaultContactSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/ContactSortFilterType";
import { mapAddressFilterToInstruction, mapCultureFilterToInstruction, mapKeywordFilterToInstruction, mapOnlyMySelectionFilterToInstruction, mapOwnersFilterToInstruction, mapResponseToAddressFilter, mapResponseToCultureFilter, mapResponseToKeywordFilter, mapResponseToOnlyMySelectionFilter, mapResponseToOwnerFilter, mapResponseToStatusFilter, mapResponseToTagFilter, mapStatusFilterToInstruction, mapTagFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedContactInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  tags: mapTagFilterToInstruction(filter.tags),
  address: mapAddressFilterToInstruction(filter.address),
  statuses: mapStatusFilterToInstruction(filter.statuses),
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  cultures: mapCultureFilterToInstruction(filter.culture),
  // TODO: This can be done better
  order: filter.contactSort.sortOption.value,
  onlyMySelection: mapOnlyMySelectionFilterToInstruction(filter.onlyMySelection),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListContactFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  tags: mapResponseToTagFilter(response.tags, values.tags),
  address: mapResponseToAddressFilter(response.address),
  statuses: mapResponseToStatusFilter(response.statuses, values.statuses),
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  culture: mapResponseToCultureFilter(response.cultures),
  contactSort: {
    sortOption: response.order
      ? getSortOption(response.order)
      : getSortOption(DefaultContactSortFilter)
  },
  onlyMySelection: mapResponseToOnlyMySelectionFilter(response.onlyMySelection)
});